import { statsGateway } from "@/gateways/statsGateway";
import { useQuery } from "@tanstack/vue-query";

export function useGetStats() {
  const query = useQuery({
    queryKey: ["stats"],
    queryFn: () => statsGateway.getStats(),
  });

  return { ...query, getStatsStatus: query.status, stats: query.data };
}
